import { createAction, props } from '@ngrx/store';

import { LastPageStateWithTabs } from '@store/types/basic-last-page-state';

/**
 * Действие для установки состояния последней страницы.
 *
 * @property {Partial<LastPageStateWithTabs>} newPageState - Новое состояние страницы.
 */
export const setLastPageStateTrailers = createAction(
  '[Trailers] Set last page state',
  props<{ newPageState: Partial<LastPageStateWithTabs> }>(),
);
